namespace $ {

	/** Read a public appendable registry without merging different signers. */
	export class $shm_hitalama_map_access_index extends $mol_object {

		static recipient_head( recipient: string ) {
			return this.$.$giper_baza_link.hash_str( 'map-access:v1:recipient:' + recipient ).peer()
		}

		static authored_units( land: $giper_baza_land, head: $giper_baza_link ) {
			land.sync()
			// The land already validates incoming Pass/Seal units. Its reactive
			// dictionary retains the latest Sand per (head, signer, self).
			// Do not use merged list/dict reads or follow Tine references here:
			// a public writer can reuse another signer's self or forge ordering
			// edges. Neither tombstones nor ordering may hide a peer's entry.
			return [ ... land._sand.get( head.str )?.values() ?? [] ]
				.flatMap( units=> [ ... units.values() ] )
				.filter( sand=> !sand.dead() )
				.toSorted( ( left, right )=> left.path().localeCompare( right.path() ) )
		}

	}

}
